// extracted by mini-css-extract-plugin
export var buttons = "_by-0";
export var buttonsActive = "_by-h";
export var cancelConfirm = "_by-1";
export var closeButton = "_by-2";
export var column = "_by-3";
export var container = "_by-4";
export var detailHeader = "_by-6";
export var detailTitle = "_by-7";
export var detailsContent = "_by-5";
export var header = "_by-8";
export var headerWithClose = "_by-9";
export var icon = "_by-a";
export var infoIcon = "_by-c";
export var informationContainer = "_by-b";
export var sideDrawer = "_by-d";
export var sideDrawerOpen = "_by-e";
export var stickyFooter = "_by-f";
export var typeOption = "_by-g";